"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _alert = _interopRequireDefault(require("@reach/alert"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var alertIntentStyles = {
  'informational': {
    background: _styles.COLORS.blue[100],
    borderColor: _styles.COLORS.blue[400]
  },
  'success': {
    background: _styles.COLORS.teal[100],
    borderColor: _styles.COLORS.teal[400]
  },
  'warning': {
    background: _styles.COLORS.maize[100],
    borderColor: _styles.COLORS.maize[400]
  },
  'error': {
    background: _styles.COLORS.orange[100],
    borderColor: _styles.COLORS.orange[500]
  }
};
var StyledAlert = ( /*#__PURE__*/0, _styledBase["default"])(_alert["default"], {
  target: "e140dfhy0",
  label: "StyledAlert"
})({
  margin: '0',
  padding: '0.5rem 0',
  borderBottom: "solid 1px transparent"
}, function (props) {
  return _objectSpread({}, alertIntentStyles[props.intent]);
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var StyledAlertInner = ( /*#__PURE__*/0, _styledBase["default"])('div', {
  target: "e140dfhy1",
  label: "StyledAlertInner"
})(process.env.NODE_ENV === "production" ? {
  name: "1blwelk",
  styles: "margin:0 auto;padding:0 1rem;"
} : {
  name: "1blwelk",
  styles: "margin:0 auto;padding:0 1rem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
});
/**
  Use Alerts to notify users of important information. 
*/

var Alert = /*#__PURE__*/function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert() {
    _classCallCheck(this, Alert);

    return _possibleConstructorReturn(this, _getPrototypeOf(Alert).apply(this, arguments));
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          intent = _this$props.intent,
          children = _this$props.children,
          className = _this$props.className,
          other = _objectWithoutProperties(_this$props, ["intent", "children", "className"]);

      return (0, _core.jsx)(StyledAlert, _extends({
        intent: intent
      }, other), (0, _core.jsx)(StyledAlertInner, {
        "data-inner-container": true
      }, children));
    }
  }]);

  return Alert;
}(_react["default"].Component);

Alert.propTypes = {
  intent: _propTypes["default"].oneOf(["informational", "error", "warning", "success"]),
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
Alert.defaultProps = {
  intent: 'informational'
};
var _default = Alert;
exports["default"] = _default;